export interface IUsage {
    amount: number;
    amountFourDecimals : number;
    duration: number;
    measuringUnit: EMeasuringUnit;
    quantity: number;
}

export enum EMeasuringUnit {
    SECOND = "SECOND",
    KB = "KB",
    B = "B",
    EVENT = "EVENT",
}
